import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PackIllustration } from './PackIllustration';
import { images } from '../data/images';
const chips = ['6 Volumes', '77 Sessions', '5 Bonuses', '300 Pages', '3-Level Dial'];
const builtFor = ['Club coaches', 'PE teachers', 'Volunteer coaches', 'Parent coaches'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it and run it'];
export function Hero() {
  return <section className="w-full bg-gradient-to-b from-white to-light" data-id="element-145" data-mp="xanqw5cpdri0">
      <div className="max-w-6xl mx-auto px-5 pt-7 pb-14 sm:pt-12 sm:pb-20" data-id="element-146" data-mp="x8jm7l6zcogo">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-147" data-mp="s9qa9x7cd5im">
          <div data-id="element-148" data-mp="nbf0fmh1qv0e">
            <p className="inline-flex items-center gap-2 rounded-full bg-court-soft px-3 py-1.5 text-[11px] font-bold uppercase tracking-[1.4px] text-court-deep" data-id="element-149" data-mp="nbyir4alzley">
              <span className="h-1.5 w-1.5 rounded-full bg-court" data-id="element-150" data-mp="381e25e7i07uk" />
              Ready-to-run sessions for badminton coaches
            </p>
            <h1 className="mt-4 font-display font-extrabold text-ink text-[34px] leading-[1.08] tracking-tight sm:text-5xl md:text-6xl" data-id="element-151" data-mp="3j6fwnlhhz5bq">
              Your next badminton session is{' '}
              <span className="whitespace-nowrap text-court bg-[linear-gradient(transparent_68%,rgba(255,201,60,0.75)_68%)]" data-id="element-152" data-mp="39a36gxl5v9lq">
                already planned.
              </span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-ink-soft" data-id="element-153" data-mp="30gq4z7916zo1">
              Badminton Class Ready is a six-volume coaching pack with 77
              sessions written out for you — from grip and serve to match play.
              Every session runs warm-up game, skill block, applied game, with a
              3-Level Dial so beginners and advanced players train on the same
              court. Print it and coach.
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-154" data-mp="2lkij82hz5q6n">
              {chips.map(chip => <li key={chip} className="rounded-full border border-line bg-white px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ink-soft" data-id="element-155" data-mp="s1rrwn4sk4tr">
                  {chip}
                </li>)}
            </ul>
          </div>

          {images.hero ? <img src={images.hero} alt="Badminton Class Ready: six volumes of ready-to-run badminton sessions" width={1200} height={886} className="w-full h-auto" data-id="element-156" data-mp="de6rj0zawjpj" /> : <PackIllustration data-id="element-157" data-mp="112g4ddejdx4j" />}
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-158" data-mp="110wo3msvrm2r">
          <div className="w-full max-w-md" data-id="element-159" data-mp="x1w80c1sexjg">
            <CtaButton data-id="element-160" data-mp="x0uyic0f6j3u">Get Badminton Class Ready</CtaButton>
          </div>

          <div className="mt-5 text-center" data-id="element-161" data-mp="3ltqbtahzursg">
            <p className="text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-162" data-mp="3hrd8stumt7zd">
              Built for
            </p>
            <ul className="mt-2 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-163" data-mp="1xa429a5swchi">
              {builtFor.map(who => <li key={who} className="flex items-center gap-1.5 text-[13px] font-semibold text-ink" data-id="element-164" data-mp="21bpnbishnx2s">
                  <span className="flex h-4 w-4 items-center justify-center rounded-full bg-green" data-id="element-165" data-mp="268g282sk4mmm">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-166" data-mp="2b2aggqpe89eb" />
                  </span>
                  {who}
                </li>)}
            </ul>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-ink-soft" data-id="element-167" data-mp="2kxc9vyqpbxmp">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-168" data-mp="2tzlds5rgssr4">
                <span className="h-1.5 w-1.5 rounded-full bg-shuttle" data-id="element-169" data-mp="2tysh5xm7zjmp" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}